const MODEL_LABELS: Record<string, string> = {
  interchange_plus: 'Interchange plus',
  flat: 'Flat',
  tiered: 'Tiered',
  cash_discount: 'Cash discount',
}

export function pricingModelLabel(model: string): string {
  return MODEL_LABELS[model] ?? model
}

export function describeProposedRates(model: string, rates: Record<string, string> | null | undefined): string {
  const value = (key: string) => {
    const raw = rates?.[key]
    return raw === undefined || raw === null || raw === '' ? '—' : raw
  }

  if (model === 'flat') {
    return `${value('flat_rate_percent')}% + $${value('per_item_fee')} per item, $${value('monthly_fee')} monthly`
  }
  if (model === 'interchange_plus') {
    return `${value('markup_percent')}% markup + $${value('per_item_fee')} per item, $${value('monthly_fee')} monthly`
  }
  if (model === 'cash_discount') {
    return `${value('program_rate_percent')}% program + $${value('per_item_fee')} per item, $${value('monthly_fee')} monthly`
  }
  if (model === 'tiered') {
    return `Qualified ${value('qualified_rate_percent')}%, mid ${value('mid_qualified_rate_percent')}%, non-qualified ${value('non_qualified_rate_percent')}%`
  }

  return 'No proposed rates'
}
